import { Modal } from 'almanac-ui/Modal'
import { BrandVisualAnalysisProcessingModalProps } from './Types'
import { usePollBrandVisualAnalysis } from 'hooks/queries/brandVisualAnalyses/usePollBrandVisualAnalysis'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useEffect, useState } from 'react'
import { Processing } from './Processing'
import { Failed } from './Failed'

const BrandVisualAnalysisProcessingModal = ({
  integration,
  id,
  onConfirm,
  onSuccess,
}: BrandVisualAnalysisProcessingModalProps) => {
  const [cycle, setCycle] = useState(0)
  const workspaceId = useCurrentWorkspaceId()
  const { data } = usePollBrandVisualAnalysis({ workspaceId, id }, { onSuccess: () => setCycle((c) => c + 1) })
  const status = data?.brand_visual_analysis?.status || 'pending'
  const failureReason = data?.brand_visual_analysis?.failure_reason || null
  const isProcessing = ['pending', 'started'].includes(status)
  const isFailed = status === 'failed'

  useEffect(() => {
    if (status === 'successful') {
      onSuccess({ initialAnalysisId: id, integration, onConfirm })
    }
  }, [status, id]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Modal.Root aria-label="Analyzing Brand">
      {isProcessing && <Processing cycle={cycle} />}
      {isFailed && <Failed failureReason={failureReason} integration={integration} />}
    </Modal.Root>
  )
}

export { BrandVisualAnalysisProcessingModal }
